import { defineStore } from "pinia";
import Services from '@/services/sutting/fileNamesServices'
import { mapFileName, mapList } from '@/helpers/mapFuncs'

export const useFileNamesStore = defineStore("fileNames", {
persist: true,
state:()=>({
    fileNames: [],
}),
getters : {
    getFileNames() {
        return this.fileNames.map(mapFileName)
    },
    getFileNamesList() {
        return (this.fileNames.map(mapFileName)).map(mapList)
    }
},
actions : {
    /** Start Sets */
    setFileNames(fileNames) {
        this.fileNames = fileNames;
    },
    /** End Sets */

    /** Start Actions */
    getByName(name) {
        let t = this.fileNames.find((x)=>x.enName.trim().toLowerCase() == name.trim().toLowerCase())
        return t?mapFileName(t):{extensions:[], size: 0}
    },
    // get(id) {
    //     return Services.get(id)
    //     .then((response)=>{
    //         this.setFileName(response.data.data)
    //         return response
    //     })
    // },
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            let data = response.data.data??[];
            // data = data.filter((x)=>x.active)
            this.setFileNames(data)
            return response
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.fileNames.push(response.data.data)
            return response
        })
    },
    edit(id, data){
        return Services.edit(id, data)
        .then((response)=>{
            console.log('response.data.data: ', response.data.data)
            this.fileNames[this.fileNames.findIndex((x)=>x.id == id)] = response.data.data
            return response
        })
    },
    delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.fileNames = this.fileNames.filter((x)=>x.id != id)
            return response
        })
    },
    /** End Actions */
}
});
